import * as React from 'react';
import { Card, Col, Popover, Row } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { renderCurrencyByCurrencyId } from '../../utils/DataAccessUtils';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';

const BudgetHeaderDisplayCard = ({ title, amount, span, message, currency, color = 'black' }) => {
	return (
		<Col span={span}>
			<Card
				title={
					<span>
						{title}
						<Popover style={{ marginTop: '-8px' }} content={message}>
							<span style={{ fontSize: '12px', color: 'rgba(0,0,0,0.6)', marginLeft: 8 }}>
								<InfoCircleOutlined />
							</span>
						</Popover>
					</span>
				}
			>
				<Row className={'items-end justify-between'}>
					<h5 className={'mb-0 font-bold'} style={{ color }}>
						<Ellipsis tooltip={true} fullWidthRecognition={true} lines={1}>
							{renderCurrencyByCurrencyId(currency.id)(amount)}
						</Ellipsis>
					</h5>
				</Row>
			</Card>
		</Col>
	);
};

export default BudgetHeaderDisplayCard;
